<section class="form-section" [ngClass]="{ mobile: rwdService.isSmallDevice, padded: optionsFlags.withPadding }">
  <div class="section-header">
    <div class="font-14" *ngIf="headerKey">
      {{ headerKey | locLabel | capitalize }} <app-required-indicator *ngIf="optionsFlags.required"></app-required-indicator>
    </div>
    <ng-content select="[section-header]" *ngIf="!headerKey"></ng-content>
    <div class="mat-caption gray" *ngIf="extraDataKey">{{ extraDataKey | locLabel }}</div>
  </div>
  <div class="section-data">
    <ng-content></ng-content>
  </div>
</section>
<mat-divider class="divider" *ngIf="optionsFlags.showDivider ?? true"></mat-divider>
